import React, { FC } from 'react';

import { Text, TextProps, addWithConfig } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';

import { StyledRewardPointCost } from './reward-point-cost.styled';

export interface IRewardPointCost extends TextProps {
  pointCost: number;
  usePrimaryColor?: boolean;
}

const RewardPointCostText: FC<React.PropsWithChildren<IRewardPointCost>> = ({
  pointCost,
  usePrimaryColor,
  children,
  ...textProps
}) => {
  return pointCost === 0 ? (
    <StyledRewardPointCost usePrimaryColor={usePrimaryColor} {...textProps}>
      {t('free').toLocaleLowerCase()}
    </StyledRewardPointCost>
  ) : (
    <Text {...textProps}>{children}</Text>
  );
};

export const RewardPointCost = addWithConfig(RewardPointCostText);
